import { Button } from "@/components/ui/button";
import { Bed, Bath, Maximize, Calendar } from "lucide-react";
import OptimizedImage from "./OptimizedImage";

export default function PropertyTypesSection() {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const propertyTypes = [
    {
      title: "Affordable 1+1 Dubai Motor City Apartment",
      price: "$250,000",
      beds: 1,
      baths: 1,
      size: "50 m²",
      availability: "12/2027",
      image: "/images/interior-01.jpg"
    },
    {
      title: "Spacious 2+1 Dubai Motor City Apartment",
      price: "$440,000",
      beds: 2,
      baths: 2,
      size: "90 m²",
      availability: "12/2027",
      image: "/images/interior-02.jpg"
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Find Your Ideal Dubai Motor City Apartment
            </h2>
            <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
              Explore our Dubai Motor City apartments, perfect for expat property Dubai seekers and savvy international investors. This is your chance for a prime Dubai apartment investment.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            {propertyTypes.map((property, index) => (
              <div 
                key={index}
                className="bg-card rounded-xl overflow-hidden border border-border hover:shadow-xl transition-shadow"
              >
                <div className="relative h-64 overflow-hidden">
                  <OptimizedImage
                    src={property.image} 
                    alt={property.title}
                    width={1200}
                    height={800}
                    className="hover:scale-105 transition-transform duration-300"
                    objectFit="cover"
                  />
                  <div className="absolute top-4 right-4 bg-accent text-accent-foreground px-4 py-2 rounded-full font-bold text-lg">
                    {property.price}
                  </div>
                </div>
                
                <div className="p-6">
                  <h3 className="text-2xl font-bold mb-4 text-card-foreground">{property.title}</h3>
                  
                  <div className="grid grid-cols-2 gap-4 mb-6">
                    <div className="flex items-center gap-2">
                      <Bed className="w-5 h-5 text-primary" />
                      <span className="text-muted-foreground">{property.beds} Bedroom{property.beds > 1 ? 's' : ''}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Bath className="w-5 h-5 text-primary" />
                      <span className="text-muted-foreground">{property.baths} Bathroom{property.baths > 1 ? 's' : ''}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Maximize className="w-5 h-5 text-primary" />
                      <span className="text-muted-foreground">{property.size}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <Calendar className="w-5 h-5 text-primary" />
                      <span className="text-muted-foreground">{property.availability}</span>
                    </div>
                  </div>
                  
                  <Button 
                    className="w-full"
                    size="lg"
                    onClick={scrollToForm}
                  >
                    Inquire About This Dubai Property
                  </Button>
                </div>
              </div>
            ))}
          </div>

          {/* Property ID Badge */}
          <div className="text-center">
            <div className="inline-block bg-primary/10 text-primary px-6 py-3 rounded-full font-semibold">
              Property ID: DXB-020
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
